import type { ComponentType } from 'react';

/** Props that `AuthGuard` passes to every add-on it renders. */
export type AuthGuardAddonProps = { className?: string };

const addons: ComponentType<AuthGuardAddonProps>[] = [];

/**
 * Registers a component that `AuthGuard` renders after the page for a signed-in user.
 * A package above `auth-ui` calls this from its `init`.
 * @param addon Component to render. Registering the same component twice has no effect.
 */
export function registerAuthGuardAddon(addon: ComponentType<AuthGuardAddonProps>): void {
  if (!addons.includes(addon)) {
    addons.push(addon);
  }
}

/**
 * Returns the registered `AuthGuard` add-ons in registration order.
 * @returns The registered add-on components.
 */
export function getAuthGuardAddons(): readonly ComponentType<AuthGuardAddonProps>[] {
  return addons;
}
